module.exports = __webpack_public_path__ + "media/images/front/icons_mypage-0587fecc50e0b7ebe746959d3b0d86d7.png";